var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._b({on:{"click":_vm.browseFile}},'v-btn',_vm.$attrs,false),[_vm._t("default"),_c('input',{ref:"input",staticClass:"d-none",attrs:{"type":"file"},on:{"change":_vm.readFile}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }